import styled from 'styled-components';

import theme from './theme';

export const CartItemButton = styled.button`
  min-width: 250px;
  display: flex;
  flex-direction: row;
  scroll-snap-align: start;
  justify-content: space-between;
  align-items: center;
  background-color: ${Styles.color.cardBackground};
  border-radius: ${Styles.borderRadius};
  box-shadow: ${Styles.boxShadow};
  margin: 4px 10px 4px 4px;
  padding: 20px 15px;
  border: none;
  cursor: pointer;
  font-weight: ${Styles.fontWeight.normal};
  font-family: ${theme.fontFamily};
  color: ${Styles.color.black};
  line-height: 1.5;
`;

export const CartItemIcon = styled.div`
  color: ${Styles.color.primary};
  font-size: 2.5rem;
  padding: 1px 6px;
  ${Styles.desktop`
    padding: 0 12px;
  `}
`;
